/* eslint-disable camelcase */
/* eslint-disable no-prototype-builtins */
import { takeLatest, call, put, all } from 'redux-saga/effects';
import {
  updateUserInfo,
  updateWalletLimit,
  setInvoiceProductList,
  setDashboardView,
  setOnboardData,
  setActivatePhyCardFromOnboardFlow,
  checkDasboardView,
  setTutorialFlag
} from '../actions/landingPageAction';
import URLS from '../constants/urls';
import history from '../utils/history';
import * as authActions from '../actions/authActions';
import cookieLib from '../helpers/cookieLib';
import * as SnackbarAction from '../actions/snackbarAction';
import { callApi, isProdURL } from '../utils/api';

const USER_INFO = 'GET_USER_INFO';
function* getUserInfo(action) {
  try {
    // data is obtained after axios call is resolved
    // debugger;
    // console.log(action.payload);
    // const data =''
    const resData = yield call(callApi, URLS.USER_INFO, 'GET', action.payload);
    // console.log(resData);
    // store data to localStorage
    // Object.keys(data.session).forEach(key, => {
    //     localStorage.setItem(key, data[key]);
    // });
    const data = resData.res_data;
    const APP_ID = isProdURL() ? 'xqmxu9c5' : 'bsh0jw3y';
    // eslint-disable-next-line no-prototype-builtins
    if (window.hasOwnProperty('Intercom')) {
      window.Intercom('boot', {
        app_id: APP_ID,
        email: data.user_info.email_id,
        user_id: data.user_info.happay_id,
        company: {
          id: data.user_info.org_id,
          name: data.user_info.org_name,
          plan: data.user_info.funding_type || '',
        },
        name: data.user_info.name,
        mobile_number: data.user_info.mobile_number,
        user_role: data.user_info.has_role,
        company_type: data.user_info.funding_type || '',
        invoice_product: false,
        kyc_status: data.user_info.kyc_status,
      });
      window.intercomSettings = {
        app_id: APP_ID,
      };
    }
    // // dispatch action to change redux state
    const userData = (resData.res_data && resData.res_data.user_info) || {};
    cookieLib.setCookieByKey('has_role', userData.has_role);
    cookieLib.setCookieByKey('org_id', userData.org_id);
    yield put(updateUserInfo(resData.res_data));
    // // redirect to home route after successful login
    // browserHistory.push('/home');
    // console.log(data)
  } catch (e) {
    // catch error on a bad axios call
    // alert using an alert library
    if (e.logout) {
      cookieLib.clearAllCookies();
      yield put(authActions.clearStore({}));
      history.push('/login');
    }
  }
}

export function* walletLimit(action) {
  try {
    const response = yield call(
      callApi,
      URLS.WALLET_LIMITS,
      'get',
      {},
      false,
      cookieLib.getCookieByKey('has_role') === 'true' ? 'Y' : 'N',
    );
    yield put(updateWalletLimit(response.res_data));
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.statusText,
        type: 'error',
      }),
    );
  }
}

export function* getInvoiceProduct(action) {
  try {
    const response = yield call(
      callApi,
      URLS.INVOICE_PRODUCT_LIST,
      'get',
      action.payload,
    );
    yield put(setInvoiceProductList(response.res_data));
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.statusText,
        type: 'error',
      }),
    );
  }
}

export function* getUserList(action) {
  // need to remove this completely .
  try {
    // const reqObjPending = {
    //   org_id: action.orgId,
    // };
    // const reqObjRegister = {
    //   content_type: 'wallet',
    //   offset: 0,
    //   limit: '0',
    //   has_role: true,
    // };
    // const [pendingUserList, regUserList] = yield all([
    //   call(callApi, URLS.PENDING_EMP_INVITE, 'GET', reqObjPending),
    //   call(callApi, URLS.SEARCH, 'GET', reqObjRegister),
    // ]);
    // if (
    //   (pendingUserList.res_data &&
    //     pendingUserList.res_data.employees &&
    //     pendingUserList.res_data.employees.length) ||
    //   (regUserList.res_data && regUserList.res_data.count)
    // ) {
    //   yield put(setDashboardView({ isAdminView: true }));
    // } else {
    //   yield put(setDashboardView({ isAdminView: false }));
    // }

    const response = yield call(callApi, URLS.USER_ONBOARD_FLOW, 'get', {});
    // console.log(response.res_data,'shdjk')
    // const data = {
    //   meta_data: { type: 'transact',dashboardCount:-1 }, // phyCardDoLater:true // addUser: true, activeCardDoLater: true
    //   kyc_status: 0,
    //   card_status: {
    //     one_time_card: true,
    //     virtual_card: true,
    //     physical_card: true,
    //   },
    //   user_addition: true,
    //   dashboard_login_count: 0,
    // };
    const data = response.res_data;
    let viewType = true;
    const { meta_data, card_status } = data;
    if (!data.meta_data) {
      viewType = false;
    }
    if (data.meta_data && !data.meta_data.type) {
      viewType = false;
    }
    if (data.kyc_status !== 0) {
      viewType = false;
    }
    if (!data.card_status) {
      viewType = false;
    }
    if (
      data.card_status &&
      Object.values(data.card_status).indexOf(false) !== -1 &&
      meta_data &&
      !meta_data.activeCardDoLater
    ) {
      viewType = false;
    }
    if (
      !data.user_addition &&
      meta_data &&
      !meta_data.addUser &&
      cookieLib.getCookieByKey('has_role') === 'true'
    ) {
      viewType = false;
    }
    if (cookieLib.getCookieByKey('has_role') === 'false') {
      data.user_addition = true;
    }
    // viewType = false;
    if (
      (cookieLib.getCookieByKey('view_type') === 'dashboard' &&
        !cookieLib.getCookieByKey('active_tab')) ||
      (meta_data && meta_data.dashboardCount >= 0)
    ) {
      viewType = true;
    }
    if (viewType && !cookieLib.getCookieByKey('view_type')) {
      cookieLib.setCookieByKey('view_type', 'dashboard');
      cookieLib.setCookieByKey('active_tab', '');
    } else if (!viewType && !cookieLib.getCookieByKey('view_type')) {
      cookieLib.setCookieByKey('view_type', 'onboardFlow');
    }
    if (!cookieLib.getCookieByKey('active_tab') && !viewType) {
      cookieLib.setCookieByKey('active_tab', 'Home');
    }
    if (viewType && cookieLib.getCookieByKey('view_type') === 'onboardFlow') {
      meta_data.isCompleted = true;
    }
    if (
      viewType &&
      meta_data &&
      (!meta_data.hasOwnProperty('dashboardCount') ||
        meta_data.dashboardCount < 0)
    ) {
      cookieLib.setCookieByKey('active_tab', 'Home');
      cookieLib.setCookieByKey('view_type', 'onboardFlow');
      viewType = false;
    }
    // debugger;
    /* here below is the logic to make animation after 3 sec */
    let tempFlowPoint = 0;
    if (meta_data && meta_data.type) {
      if (
        meta_data.type === 'transact' &&
        (card_status.physical_card === null ||
          card_status.physical_card ||
          meta_data.phyCardDoLater) &&
        (card_status.virtual_card || card_status.virtual_card === null) &&
        (card_status.one_time_card || card_status.one_time_card === null) &&
        data.kyc_status === 0
      ) {
        if (data.user_addition || meta_data.addUser) {
          tempFlowPoint = 13;
        } else {
          tempFlowPoint = 12;
        }
      } else if (data.user_addition) {
        if (
          ((card_status.physical_card === null ||
            card_status.physical_card ||
            meta_data.phyCardDoLater) &&
            (card_status.virtual_card || card_status.virtual_card === null) &&
            (card_status.one_time_card || card_status.one_time_card === null) &&
            data.kyc_status === 0) ||
          meta_data.activeCardDoLater
        ) {
          tempFlowPoint = 23;
        } else {
          tempFlowPoint = 22;
        }
      }
    }
    data.flowPoint = tempFlowPoint;
    if (window.sessionStorage.length === 0) {
      if (tempFlowPoint === 12) {
        window.sessionStorage.setItem('step_2_completed', 1);
        window.sessionStorage.setItem('step_1_animation_count', 1);
        window.sessionStorage.setItem('step_2_animation_count', 1);
        let activeVal = cookieLib.getCookieByKey('active_tab');
        activeVal = `${activeVal}Cards`;
        cookieLib.setCookieByKey('active_tab', activeVal);
      } else if (tempFlowPoint === 22) {
        window.sessionStorage.setItem('step_3_completed', 1);
        window.sessionStorage.setItem('step_1_animation_count', 1);
        window.sessionStorage.setItem('step_3_animation_count', 1);
      } else if (tempFlowPoint === 13 || tempFlowPoint === 23) {
        window.sessionStorage.setItem('all_step_completed', 1);
        window.sessionStorage.setItem('step_1_animation_count', 1);
        window.sessionStorage.setItem('step_2_animation_count', 1);
        window.sessionStorage.setItem('step_3_animation_count', 1);
      }
    }
    const pathName = history.location.pathname;
    const query = history.location.search || '';
    if (
      meta_data.dashboardCount === 0 &&
      pathName === '/dashboard' &&
      query.search('infostep') === -1
    ) {
      history.replace(`/dashboard?infostep=0`);
    }
    // console.log(viewType, meta_data , data, 'vvi' )
    if (
      (tempFlowPoint === 13 || tempFlowPoint === 23) &&
      meta_data.dashboardCount >= 0
    ) {
      cookieLib.setCookieByKey('view_type', 'dashboard');
      cookieLib.setCookieByKey('active_tab', '');
    }

    yield put(setOnboardData(data));
    yield put(setDashboardView({ isAdminView: viewType }));
  } catch (error) {
    // console.log('error',error)
    yield put(setOnboardData({}));
    cookieLib.setCookieByKey('view_type', 'onboardFlow');
    yield put(setDashboardView({ isAdminView: false }));
  }
}
export function* activatecard(action) {
  try {
    let response = {};
    if (action.payload) {
      response = yield call(
        callApi,
        URLS.ACTIVATE_CARD,
        'POST',
        action.payload,
      );
    }
    const activatestatus = {
      isActivated: true,
      response: response.res_str || '',
    };
    // yield put(setLoader(false));
    yield put(setActivatePhyCardFromOnboardFlow(activatestatus));
  } catch (error) {
    // yield put(setLoader(false));
    const activatestatus = {
      isActivated: false,
      response: error.data.res_str,
    };
    yield put(setActivatePhyCardFromOnboardFlow(activatestatus));
  }
}
export function* physicalCardLater(action) {
  try {
    const response = yield call(callApi, URLS.USER_ONBOARD_FLOW, 'POST', {
      data: JSON.stringify(action.data),
    });
    yield put(checkDasboardView({}));
  } catch (error) {
    // yield put(setLoader(false));
  }
}

function* redirectToKycPortal(action) {
  try {
    const response = yield call(callApi, URLS.VIDEOKYC, 'POST', action.payload);
    const link = (response.res_data && response.res_data.redirect_url) || '';
    // yield put(KycAction.setVideoKycLink(link));
    // yield put(
    //   SnackbarAction.openSnackbar({
    //     message: response.res_str,
    //     type: 'success',
    //   }),
    // );
    if (link) {
      window.open(link, '_blank');
    }
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}

function* setOnboardingMetaConfig(action) {
  const response = yield call(callApi, URLS.USER_ONBOARD_FLOW, 'POST', {
    data: JSON.stringify(action.data),
  });
  yield put(checkDasboardView({}));
}

function* getTutorialFlag() {
  try {
    const response = yield call(callApi, URLS.TUTORIAL_FLAG, 'get');
    if (cookieLib.getCookieByKey('show_ipp_tutorial_flag') !== 'false') {
      yield put(setTutorialFlag(response.res_data));
    }
  } catch (error) {
    // yield put(setTutorialFlag({"show_ipp_tutorial_flag": true, "show_epic_tutorial_flag": true}));
    console.log("error", error)
  }
}

export function* landgingPageWatcherSaga() {
  yield takeLatest(USER_INFO, getUserInfo);
  yield takeLatest('GET_WALLET_LIMIT', walletLimit);
  yield takeLatest('GET_INVOICE_PRODUCT', getInvoiceProduct);
  yield takeLatest('CHECK_DASHBOARD_VIEW', getUserList);
  yield takeLatest('ACTIVATE_CARD_ONBOARD', activatecard);
  yield takeLatest('SET_PHY_CARD_LATER', physicalCardLater);
  yield takeLatest('REDIRECT_TO_KYC_PORTAL', redirectToKycPortal);
  yield takeLatest('UPDATE_META_DATA', setOnboardingMetaConfig);
  yield takeLatest('GET_TUTORIAL_FLAG', getTutorialFlag)
}
